export default __webpack_public_path__ + "static/media/CPGJobs-Logo.65116e37.svg";